import React, {
  FC,
  useContext,
} from 'react';
import { styled, CSSObject } from '@core-ui/react-stitch';
import GridContext from '../GridContext';
import { GenerateItemStyles, GridRootStyleProps, GridRootProps, } from './types';

const generateItemStyles = ({
  columnSize,
  numberOfColumns,
  spacing,
}: GenerateItemStyles): CSSObject => {
  const percentage = columnSize ? (columnSize * 100) / numberOfColumns : 100;
  const width = `${percentage}%`;

  return {
    boxSizing: 'border-box',
    flexBasis: width,
    flexGrow: 0,
    margin: 0,
    maxWidth: width,
    padding: `${spacing}em`,
  };
};

export const GridRootStyle = styled.div<GridRootStyleProps>(
  ({ numberOfColumns, spacing, columnSize }: GridRootStyleProps) => ({
    ...generateItemStyles({
      columnSize,
      numberOfColumns,
      spacing,
    }),
  })
);

const GridRoot: FC<GridRootProps> = (props: GridRootProps) => {
  const {
    spacing = 0.5,
    elementSizes,
    children,
  } = props;

  const { size, numberOfColumns } = useContext(GridContext);

  return (
    <GridRootStyle
      columnSize={elementSizes[size]}
      numberOfColumns={numberOfColumns}
      spacing={spacing}
    >
      {children}
    </GridRootStyle>
  );
};

export default GridRoot;
